module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"product":"Products","noProducts":"No products available"},"es":{"product":"Productos","noProducts":"No hay productos disponibles"}}')
  delete Component.options._Ctor
}
